import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Form } from "antd";

import {
    usersSetMainEmailModal,
    usersSetMainEmailShowModal,
    usersSetMainEmailSelectedUser
} from '../../../../store/actions/usersActions';


import Utils from "../../../../commons/utils/utils";
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";

import AccountModal from "../../../../commons/components/AccountModal"
import Loading from "../../../../commons/components/loading";

import changeEmailModalModes from './changeEmailModalModes'
import AccountInputValue from "../../../../commons/components/accountInputValue";

function ChangeEmailModal({ onSave }) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { showMainEmailUserModal, modeMainEmailModal, mainEmailSelectedUser } = useSelector((state) => state.users);
    const [permissions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [errorUser, setErrorUser] = useState("");
    const [userNewEmail, setUserNewEmail] = useState("");

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    function renderButtons() {
        if (modeMainEmailModal == changeEmailModalModes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSave} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    async function handleSave() {
        if (!Utils.validateEmail(userNewEmail)) {
            setErrorUser("E-mail inválido.");
        } else {
            let body = {
                "user_id": mainEmailSelectedUser.id,
                "previous_email": mainEmailSelectedUser.email,
                "new_email": userNewEmail.toLowerCase()
            }
    
            const response = await callChangeMainEmailService(body);
            if (response && !response.data.response.error) {
                Message.showSuccess(response.data.response.message);
    
                onSave();
                handleClear();
            }
        }
    }

    async function callChangeMainEmailService(body) {
        try {
            let response = await Http.put(`/users/change-main-email`, body, Http.headers);
            if(response.data) {
                let email = response.data.data;

                let user = mainEmailSelectedUser;
                user.email = email;
                user.emails[0] = email;
                usersSetMainEmailSelectedUser(user);
            }
            return response
        } catch (error) {
            if (error.response) {
                setErrorUser(error.response.data.response.message)
            }
            else {
                Message.showError("Não foi possível efetuar a alteração.");
            }
        }
    }

    function handleClear() {
        dispatch(usersSetMainEmailShowModal(false));
        dispatch(usersSetMainEmailModal(null));
        
        setErrorUser("");

        setLoading(false);
    }

    function handleOnChangeEmail(input) {
        setUserNewEmail(input.target.value);
        setErrorUser("");
    }

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <Form>
                    <Form.Item>
                        <AccountInputValue 
                            name={"new_email"} 
                            labelText={"Alterar e-mail principal"}
                            value={userNewEmail}
                            onChange={(e) => { handleOnChangeEmail(e) }}
                            hasError={errorUser} 
                            error={errorUser} />
                    </Form.Item>
                </Form>
            )
        }
    }

    return (
        <AccountModal
            visible={showMainEmailUserModal}
            title={"E-mail principal"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderForm()}
        </AccountModal>
    )
}

export default ChangeEmailModal;

